import { store } from "@redux"
import { idb } from "utils"
import * as types from "../types/combos"
import { getCombos } from "services"

export const fetchAllCombos = () => (
  async (dispatch) => {
    const branchId =
      store.getState().userAccountInfo.branchId

    const combosFromDatabase =
      await idb.getAllItemsFromDatabase(
        branchId,
        "combos"
      )

    dispatch({
      type: types.SET_ALL_COMBOS,
      combos: combosFromDatabase
    })

    const combos = await getCombos({ branchId })

    dispatch({
      type: types.SET_ALL_COMBOS,
      combos
    })

    idb.saveItemsToDatabase(
      branchId,
      "combos",
      combos
    )
  }
)

export const addCombo = (newCombo) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "combos",
    [newCombo]
  )

  return {
    type: types.ADD_COMBO,
    newCombo
  }
}

export const updateCombo = (newCombo) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "combos",
    [newCombo]
  )

  return {
    type: types.UPDATE_COMBO,
    newCombo
  }
}

export const updateCombos = (newCombos) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "combos",
    newCombos
  )

  return {
    type: types.UPDATE_COMBOS,
    newCombos
  }
}

export const deleteCombo = (comboId) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.deleteItemsFromDatabase(
    branchId,
    "combos",
    [comboId]
  )

  return {
    type: types.DELETE_COMBO,
    comboId
  }
}

export const clearCombos = () => ({
  type: types.CLEAR_COMBOS
})